<template>


    <div class="container-geral">
      <div class="container-imagem">
        <div class="imagem">
      <div class="imagem_empresa">
            <img :src="imagemEmpresa" @error="event => event.target.src = require('@/assets/imgs/grupo_jauense_logo.svg')" >
      </div>
    </div>
        <div class="container-titulo-subtitulo">
          <div class="titulo-fluxos"> {{titulo}} </div>
          <div class="subtitulo-fluxos"> {{subtitulo}}</div>
        </div>
      </div>      
    </div>
</template>

<script>
import gtitulosteps from './g-titulo-steps.js' 
export default gtitulosteps
</script>

<style scoped>


img{
    width: 180px;
    height: 60px;
}    
    @media (min-width:310px) {
        
    }
    
    @media (min-width:368px) {
    
    }
    
    @media (min-width:600px) {
    
    }
    
    @media (min-width:801px) {

        .subtitulo-fluxos {
    color: #8a8a8a;
    width: 50%;

}
        .imagem{
    grid-area: 1/1/1/1;
    justify-self: left;
    text-align: left;
}

.container-imagem{
    width: 80%;
    height: 100%;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    justify-content: center;

}
.container-geral{
width: 100%;
height: 100%;
display: flex;
flex-direction: column;
align-items: center;
justify-content:center ;

}
.container-titulo-subtitulo{
  grid-area: 1/1/1/3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
    }
    
    @media (min-width:1025px) { 
        
    }
    
    @media (min-width:1281px) { 
        
    }
    
</style>
